import React from "react";

export function SharedSpiroView(){
    //TODO implement
    return (
        <div/>
    );
}